import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {GelContentContainer, Video, ButtonCta} from "cw-styleguide-react";
import {route} from "../routes";
import config from '../config';
import i18n from '../i18n';
import Helmet from 'react-helmet';

class LandingView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('app.name')}</title>
          <meta name={'description'} content={this.props.t('app.description')}/>
        </Helmet>
        <GelContentContainer>
          <h1>{this.props.title}</h1>
          {this.props.mediaLocation &&
            <div className={'gel-xs-mb-30 gel-sm-mb-30 gel-md-mb-30 gel-lg-mb-30 gel-xl-mb-30'}>
              <Video video={{
                url:this.props.t('local:landing.video.url'),
                title:this.props.t('local:landing.video.title'),
                vtt:this.props.t('local:landing.video.vtt')}}/>
            </div>
          }
          <p className="style style--introduction">{this.props.introduction}</p>
          <div className={'gel-xs-mb-10 gel-sm-mb-10 gel-md-mb-10 gel-lg-mb-10 gel-xl-mb-10'}>
            <ButtonCta url={route('whereDoYouGainYourEnergyFrom')}
                       title={this.props.buttonAlt}>{this.props.buttonText}</ButtonCta>
          </div>
          <p>{this.props.credits}</p>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation('local')(LandingView);
